import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeLatest } from "redux-saga/effects";

import { FETCH_INVOICE_TRIGGER } from "./constants";

import {
  fetchInvoicesError,
  fetchInvoicesSuccess,
  fetchingInvoices,
} from "./actions";
import { IFetchInvoiceTriggerAction } from "./types";
import userAPIService from "../../services/api/user";
import { Invoice } from "../../types/common";
import { MAX_INVOICES_NUMBER } from "../user";

export function* fetchInvoices({
  payload,
}: IFetchInvoiceTriggerAction): SagaIterator {
  yield put(fetchingInvoices(payload));

  let invoicesData: Invoice[] = [];
  let lastError: any;
  const failedSubscriptionIds: string[] = [];

  // Copy before reversing to avoid mutating store state.
  for (const item of [...payload.subscriptionIds].reverse()) {
    try {
      const SpInvoicesData = yield call(
        [userAPIService, userAPIService.getInvoices],
        {
          customerId: payload.customerId,
          subscriptionId: item,
        },
      );

      invoicesData = [...invoicesData, ...SpInvoicesData];
    } catch (error) {
      // Record failure but continue; only fail if no invoices were read.
      failedSubscriptionIds.push(item);
      lastError = error;
      // eslint-disable-next-line no-console
      console.error(`Failed to fetch invoices of subscription ${item}`, error);
    }

    if (invoicesData.length > MAX_INVOICES_NUMBER) {
      break;
    }
  }

  if (failedSubscriptionIds.length && !invoicesData.length) {
    yield put(fetchInvoicesError(lastError));
  } else {
    yield put(
      fetchInvoicesSuccess({
        invoices: invoicesData,
        failedSubscriptionIds,
      }),
    );
  }
}

export function* watchFetchBillingHistory(): SagaIterator {
  yield takeLatest(FETCH_INVOICE_TRIGGER, fetchInvoices);
}

export function* billingHistorySaga(): SagaIterator {
  yield all([fork(watchFetchBillingHistory)]);
}
